/**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'Notificações mais recentes',
    titleMeta: 'Mostra as notificações mais recentes na aplicação CamAPS FX',
    descriptionMeta: 'Aqui encontra o texto das notificações mais recentes na aplicação relativas a atualizações da aplicação, notificações de segurança e atualizações do manual do utilizador',
    keywords: 'Notificações' ,
    localeMeta: 'pt_PT',

    heading: 'Notificações mais recentes',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'',
    body_132:'',

    header_131:'',
    body_131:'',

    header_130:'',
    body_130:'',

    header_129:'',
    body_129:'',

    header_128:'',
    body_128:'',

    header_127:'',
    body_127:'',

    header_126:'',
    body_126:'',

    header_125:'',
    body_125:'',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'',
    body_122:'',

    header_121:'',
    body_121:'',
    header_120:'',
    body_120:'',

    header_119:'',
    body_119:'',

    header_118:'',
    body_118:'',

    header_117:'',
    body_117:'',

    header_116:'',
    body_116:'',

    header_115:'',
    body_115:'',

    header_114:'',
    body_114:'',

    header_113:'',
    body_113:'',

    header_112:'Desativação das versões de Android anteriores à versão 1.4(192) (apenas Dana) 03/08/2026',
    body_112:'Caro utilizador do CamAPS FX, por motivos de cibersegurança, as versões ANTERIORES À 1.4(192) serão DESCONTINUADAS em 31/08/2026. Certifique-se de que a sua aplicação é ATUALIZADA para a versão 1.4(192) antes desta data. Se tiver alguma questão, contacte o Serviço de Apoio ao Cliente da ATUK.',

    header_111:'Desativação das versões de Android anteriores à versão 1.4(192) (apenas YpsoPump) 03/08/2026',
    body_111:'Caro utilizador do CamAPS FX, por motivos de cibersegurança, as versões ANTERIORES À 1.4(192) serão DESCONTINUADAS em 31/08/2026. Certifique-se de que a sua aplicação é ATUALIZADA para a versão 1.4(192) antes desta data. Se tiver alguma questão, contacte o Serviço de Apoio ao Cliente da mylife-Diabetescare.',

    header_110:'Mensagem da Abbott (apenas para o Reino Unido) 26/06/2026',
    body_110:'ATUE AGORA: O sensor FreeStyle Libre 3 deixou de estar disponível na sua farmácia. Fale com o seu profissional de saúde para atualizar a sua prescrição para o novo sensor FreeStyle Libre 3 Plus. Saiba mais em ',
    body_110_link_text:'Sistema FreeStyle Libre 3 | Monitorização contínua da glicose | Abbott',
    body_110_end: '.',
    body_110_link:'https://www.freestyle.abbott/uk-en/products/freestyle-libre-3.html',

    header_109:'Lançamento do Android OS 17 24/06/2026',
    body_109:'O Android irá lançar em breve o OS 17. Para garantir a utilização ininterrupta da aplicação CamAPS FX, consulte o website do fabricante do sensor para verificar a compatibilidade do smartphone e do sistema operativo ANTES de atualizar o seu dispositivo Android para o OS 17. As atualizações automáticas poderão estar ATIVADAS por predefinição nas definições do telemóvel; DESATIVE-AS.',

    header_108:'Dexcom G7 disponível (apenas YpsoPump) 23/06/2026',
    body_108:'A integração do sistema CGM Dexcom G7 já está disponível! Os utilizadores que estejam a mudar do Dexcom G6 podem encontrar um guia de transição, orientações para resolução de problemas e uma visão geral dos sistemas CGM compatíveis no nosso website: www.mylife-diabetescare.com.',

    header_107:'Atualização do manual do utilizador (apenas Dana) 22/06/2026',
    body_107:'Já está disponível uma versão atualizada do manual do utilizador. Pode aceder-lhe a partir do menu principal do CamAPS FX, selecionando Ajuda.',

    header_106:'Atualização do manual do utilizador (apenas YpsoPump) 22/06/2026',
    body_106:'Já está disponível uma versão atualizada do manual do utilizador. Pode aceder-lhe a partir do menu principal do CamAPS FX, selecionando Ajuda.',

    header_105:'',
    body_105:'',

    header_104:'Atualização da aplicação Android (apenas Dana) 12/06/2026',
    body_104:'Caro utilizador do CamAPS FX, uma nova versão do CamAPS FX, 1.4(192), ficará disponível nos próximos dias. Para escolher quando pretende efetuar a atualização, DESATIVE AS ATUALIZAÇÕES AUTOMÁTICAS na App Store. Para quaisquer questões, contacte o Serviço de Apoio ao Cliente da ATUK.',

    header_103:'Atualização da aplicação Android (apenas YpsoPump) 12/06/2026',
    body_103:'Caro utilizador do CamAPS FX, uma nova versão do CamAPS FX, 1.4(192), ficará disponível nos próximos dias. Para escolher quando pretende efetuar a atualização, DESATIVE AS ATUALIZAÇÕES AUTOMÁTICAS na App Store. Para quaisquer questões, contacte o Serviço de Apoio ao Cliente da mylife-Diabetescare.',

    header_102:'',
    body_102:'',

    header_101:'',
    body_101:'',

    header_100:'',
    body_100:'',

    header_99:'',
    body_99:'',

    header_98:'Descontinuação de sistemas operativos antigos 22/05/2026',
    body_98:'Enquanto preparamos a próxima atualização da aplicação, tenha em atenção que o CamAPS FX será APENAS compatível com telemóveis compatíveis com o sensor que utilizem o Android OS 13 ou posterior, ou o Apple iOS 18 ou posterior. Após este lançamento, os utilizadores com telemóveis que utilizem versões ANTERIORES ao Android OS 13 ou ao iOS 18 NÃO poderão ATUALIZAR nem REINSTALAR o CamAPS FX.',

    header_97:'Atualização da aplicação para iOS 22/05/2026',
    body_97:'Caro utilizador do CamAPS FX, uma nova versão do CamAPS FX, 1.4(195), ficará disponível nos próximos dias. Para escolher quando pretende efetuar a atualização, DESATIVE AS ATUALIZAÇÕES AUTOMÁTICAS na App Store. Os utilizadores de versões ANTERIORES ao Apple iOS 18 NÃO poderão ATUALIZAR o CamAPS FX para esta versão. Já está disponível uma versão atualizada do manual do utilizador. Para quaisquer questões, contacte o Serviço de Apoio ao Cliente da mylife-Diabetescare.',

    header_96:'',
    body_96:'',

    header_95:'',
    body_95:'',

    header_94:'',
    body_94:'',

    header_93:'Desativação das versões de iOS anteriores à versão 1.4(193) (apenas YpsoPump) 22/04/2026',
    body_93:'Caro utilizador do CamAPS FX, por motivos de cibersegurança, as versões ANTERIORES À 1.4(193) serão DESCONTINUADAS em 30 de abril. Certifique-se de que a sua aplicação é ATUALIZADA para a versão 1.4(193) antes desta data. Se tiver alguma questão, contacte o Serviço de Apoio ao Cliente da mylife-Diabetescare.',

    header_92:'Descontinuação de sistemas operativos antigos 21/04/2026',
    body_92:'Por motivos de cibersegurança, a partir de 30 DE JUNHO DE 2026, o mylife CamAPS FX será APENAS compatível com telemóveis compatíveis com o sensor que utilizem os seguintes sistemas operativos: Android OS 13 ou posterior e Apple iOS 18 ou posterior. Os utilizadores de sistemas operativos ANTERIORES ao Android OS 13 ou ao Apple iOS 18 NÃO poderão ATUALIZAR nem REINSTALAR o mylife CamAPS FX após esta data.',

    header_91:'',
    body_91:'',
    body_91_link_text:'',
    body_91_end: '',
    body_91_link:'',

    header_90:'',
    body_90:'',

    header_89:'Atualização do Dexcom G7 (apenas YpsoPump) 07/04/2026',
    body_89:'Estamos cada vez mais perto! A compatibilidade do sistema CGM Dexcom G7 com o mylife CamAPS FX estará disponível até ao verão de 2026. Manteremos os utilizadores informados à medida que se aproxima a disponibilização.',

    header_88:'',
    body_88:'',

    header_87:'Desativação das versões de iOS anteriores à versão 1.4(193) (apenas YpsoPump) 16/03/2026',
    body_87:'Caro utilizador do CamAPS FX, por motivos de cibersegurança, as versões ANTERIORES À 1.4(193) serão DESCONTINUADAS em 31 de março. Certifique-se de que a sua aplicação é ATUALIZADA para a versão 1.4(193) antes desta data. Se tiver alguma questão, contacte o Serviço de Apoio ao Cliente da mylife-Diabetescare.',

    header_86:'Mensagem da Abbott (apenas para o Reino Unido) 09/03/2026',
    body_86:'Importante: O sensor FreeStyle Libre 3 será descontinuado em 31 de março de 2026. Fale com o seu profissional de saúde para atualizar a sua prescrição para o novo sensor FreeStyle Libre 3 Plus. Saiba mais em ',
    body_86_link_text:'Sistema FreeStyle Libre 3 | Monitorização contínua da glicose | Abbott',
    body_86_end: '.',
    body_86_link:'https://www.freestyle.abbott/uk-en/products/freestyle-libre-3.html',

    header_85:'',
    body_85:'',

    header_84:'',
    body_84:'',

    header_83:'',
    body_83:'',

    header_82:'',
    body_82:'',

    header_81:'Atualização da aplicação Android (apenas YpsoPump) 26/01/2026',
    body_81:'Caro utilizador do CamAPS FX, uma NOVA VERSÃO da aplicação ficará disponível nos próximos dias - 1.4(190). DESATIVE AS ATUALIZAÇÕES AUTOMÁTICAS do CamAPS FX na App Store para selecionar o momento de atualização pretendido. Por motivos de cibersegurança, as versões ANTERIORES À 1.4(190) serão DESCONTINUADAS em 31 de março. Se tiver alguma questão, contacte o Serviço de Apoio ao Cliente da mylife-Diabetescare.',

    header_80:'',
    body_80:'',

    header_79:'',
    body_79:'',

    header_78:'',
    body_78:'',

    header_77:'Mensagem da mylife-Diabetescare (apenas YpsoPump) 17/12/2025',
    body_77:'Apenas para o Reino Unido e a República da Irlanda - É importante que, a partir de hoje, volte a encher os reservatórios da mylife YpsoPump. Isto destina-se a garantir a continuidade da terapêutica para todos. Agradecemos o seu apoio!',

    header_76:'',
    body_76:'',

    header_75:'Mensagem da mylife-Diabetescare (apenas YpsoPump) 09/12/2025',
    body_75:'Apenas para a Nova Zelândia - Pode voltar a encher o reservatório da mylife YpsoPump uma vez, no prazo de 7 dias após o enchimento inicial. Saiba mais na página Reservatório do website mylife-diabetescare.',

    header_74:'Mensagem da mylife-Diabetescare (apenas YpsoPump) 09/12/2025',
    body_74:'Pode voltar a encher o reservatório da mylife YpsoPump uma vez, no prazo de 7 dias após o enchimento inicial. Saiba mais na página Reservatório do website mylife-diabetescare.',

    header_73:'',
    body_73:'',
    body_73_link_text:'',
    body_73_end: '',
    body_73_link:'',

    header_72:'Informação de segurança importante sobre o sensor do sistema FreeStyle Libre 3 (apenas para o Reino Unido) 25/11/2025',
    body_72:'A Abbott identificou que alguns sensores FreeStyle Libre 3 e FreeStyle Libre 3 Plus podem apresentar leituras de glicose incorretamente baixas. Aceda a',
    body_72_link_text:'www.FreeStyleCheck.com',
    body_72_end: ' para verificar se o(s) seu(s) sensor(es) atual(is) ou não utilizado(s) poderão estar afetados. Se as leituras do sensor não corresponderem aos seus sintomas ou expectativas, desative o Auto-mode e utilize um medidor de glicose no sangue para tomar decisões de tratamento. Se tiver questões ou precisar de comunicar qualquer problema com o sensor do sistema FreeStyle Libre 3, contacte o Serviço de Apoio ao Cliente da Abbott através do 0800 170 1177. O número de série do seu sensor atual pode ser consultado no menu da aplicação, na secção Sensor.',
    body_72_link:'https://www.FreeStyleCheck.com',

    header_71:'Informação de segurança importante sobre o sensor do sistema FreeStyle Libre 3 (apenas para a Suíça) 25/11/2025',
    body_71:'A Abbott identificou que alguns sensores FreeStyle Libre 3 e FreeStyle Libre 3 Plus podem apresentar leituras de glicose incorretamente baixas. Aceda a',
    body_71_link_text:'www.FreeStyleCheck.com',
    body_71_end: ' para verificar se o(s) seu(s) sensor(es) atual(is) ou não utilizado(s) poderão estar afetados. Se as leituras do sensor não corresponderem aos seus sintomas ou expectativas, desative o Auto-mode e utilize um medidor de glicose no sangue para tomar decisões de tratamento. Se tiver questões ou precisar de comunicar qualquer problema com o sensor do sistema FreeStyle Libre 3, contacte o Serviço de Apoio ao Cliente da Abbott através do 08 00 804 404. O número de série do seu sensor atual pode ser consultado no menu da aplicação, na secção Sensor.',
    body_71_link:'https://www.FreeStyleCheck.com',

    header_70:'Informação de segurança importante sobre o sensor do sistema FreeStyle Libre 3 Plus (apenas para a Nova Zelândia) 26/11/2025',
    body_70:'Está a ser recolhido um determinado número de sensores. Leia atentamente esta mensagem para obter instruções. A Abbott identificou que alguns sensores FreeStyle Libre 3 Plus podem apresentar leituras de glicose falsamente baixas. Aceda a ',
    body_70_link_text:'www.FreeStyleCheck.com',
    body_70_end: ' para verificar se o(s) seu(s) sensor(es) atual(is) ou não utilizado(s) poderão estar afetados. Se as leituras do sensor não corresponderem aos seus sintomas ou expectativas, desative o Auto-mode e utilize um medidor de glicose no sangue para tomar decisões de tratamento. Se tiver questões sobre o sistema FreeStyle Libre 3 Plus ou tiver tido algum problema, contacte o Serviço de Apoio ao Cliente da Abbott através do 0800 106 100 (opção 2), 7 dias por semana, das 9h00 às 19h00, excluindo feriados. O número de série do seu sensor atual pode ser consultado no menu da aplicação, na secção Sensor.',
    body_70_link:'https://www.FreeStyleCheck.com',
	
    header_69:'Atualização da aplicação para iOS (apenas YpsoPump) 25/11/2025',
    body_69:'Caro utilizador do mylife CamAPS FX, uma NOVA VERSÃO da aplicação ficará disponível nos próximos dias. DESATIVE AS ATUALIZAÇÕES AUTOMÁTICAS do CamAPS FX na App Store para selecionar o momento de atualização pretendido. A sua versão atual será DESCONTINUADA em 9 de dezembro de 2025. Se tiver alguma questão, contacte o Serviço de Apoio ao Cliente da Ypsomed.',
	
    header_68:'Atualização da aplicação para iOS (apenas YpsoPump) 24/11/2025',
    body_68:'Apenas para a Austrália e a Nova Zelândia - Caro utilizador do mylife CamAPS FX, uma NOVA VERSÃO da aplicação ficará disponível nos próximos dias. DESATIVE AS ATUALIZAÇÕES AUTOMÁTICAS do CamAPS FX na App Store para selecionar o momento de atualização pretendido. A sua versão atual será DESCONTINUADA em 9 de dezembro de 2025. Se tiver alguma questão, contacte o Serviço de Apoio ao Cliente da Ypsomed.',
	
    header_67:'Alterações à Amazon Appstore (apenas Dana) 13/11/2025',
    body_67:'A aplicação CamAPS FX está agora disponível no GOOGLE PLAY para Android OS 12 a 15. Consulte as Perguntas frequentes no website da CamDiab para obter INSTRUÇÕES DE TRANSIÇÃO. A versão da AMAZON APPSTORE será DESCONTINUADA em 5 DE JANEIRO DE 2026. Para utilizar o Companion, TANTO o utilizador COMO o Companion TÊM DE utilizar a versão do Google Play.',

    header_66:'CORREÇÃO DO PRODUTO: aplicação mylife CamAPS FX (apenas Austrália) 29/10/2025',
    body_66:'Leia este importante aviso de correção do produto',
    body_66_link_text:'aviso',
    body_66_end: '',
    body_66_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Final+web+statement+29+Oct+2025+for+publication.pdf',

    header_65:'INFORMAÇÃO DE SEGURANÇA IMPORTANTE (APENAS AUSTRÁLIA) 28/10/2025',
    body_65:'Leia e confirme que leu o importante aviso de segurança',
    body_65_link_text:'N-0125',
    body_65_end: '. Aceda ao Menu da aplicação -> Avisos de segurança.',
    body_65_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+mylife+Users+EN_AU+Final.pdf',

    header_64:'INFORMAÇÃO DE SEGURANÇA IMPORTANTE (APENAS NOVA ZELÂNDIA) 28/10/2025',
    body_64:'Leia e confirme que leu o importante aviso de segurança',
    body_64_link_text:'N-0125',
    body_64_end: '. Aceda ao Menu da aplicação -> Avisos de segurança.',
    body_64_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+mylife+Users+EN_NZ+Final.pdf',

    header_63:'INFORMAÇÃO DE SEGURANÇA IMPORTANTE (APENAS REINO UNIDO E DANA) 28/10/2025',
    body_63:'Leia e confirme que leu o importante aviso de segurança',
    body_63_link_text:'N-0125',
    body_63_end: '. Aceda ao Menu da aplicação -> Avisos de segurança.',
    body_63_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+Users+DANA+EN+Final.pdf',

    header_62:'INFORMAÇÃO DE SEGURANÇA IMPORTANTE (APENAS REINO UNIDO E YPSOPUMP) 28/10/2025',
    body_62:'Leia e confirme que leu o importante aviso de segurança',
    body_62_link_text:'N-0125',
    body_62_end: '. Aceda ao Menu da aplicação -> Avisos de segurança.',
    body_62_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+mylife+Users+EN+Final.pdf',

    header_61:'Atualização da aplicação para iOS (apenas YpsoPump) 02/10/2025',
    body_61:'Para obter o melhor desempenho da aplicação, ATUALIZE o mylife CamAPS FX para a VERSÃO MAIS RECENTE (1.4(192)) através da Apple App Store.',

    header_60:'Alterações à Amazon Appstore (apenas Dana) 22/09/2025',
    body_60:'A aplicação CamAPS FX está agora disponível no Google Play para Android OS 12 a 15. Consulte as Perguntas frequentes no website da CamDiab para obter INSTRUÇÕES DE TRANSIÇÃO. Para obter o melhor desempenho, ATUALIZE a aplicação CamAPS FX para a VERSÃO MAIS RECENTE no Google Play. Para utilizar o Companion, TANTO o utilizador COMO o Companion têm de utilizar a versão do Google Play.',

    header_59:'Atualização da aplicação para iOS (apenas YpsoPump) 22/09/2025',
    body_59:'Caro utilizador do mylife CamAPS FX, uma NOVA VERSÃO da aplicação ficará disponível nos próximos dias. DESATIVE AS ATUALIZAÇÕES AUTOMÁTICAS do CamAPS FX na App Store para selecionar o momento de atualização pretendido. Ficará disponível uma nova versão do manual do utilizador. Se tiver alguma questão, contacte o Serviço de Apoio ao Cliente da Ypsomed.',

    header_58:'Lançamento do iOS 26 (apenas YpsoPump) 13/09/2025',
    body_58:'A Apple lançará em breve o iOS 26. Para garantir a utilização ininterrupta da aplicação mylife CamAPS FX, consulte o website do fabricante do sensor para verificar a compatibilidade do smartphone e do sistema operativo antes de atualizar o seu iPhone para o iOS 26. Nota: As atualizações automáticas poderão estar ativadas por predefinição nas definições do telemóvel; desative-as.',
};
